(function () {
  var S = window.SKYLIFF || {};
  var drawer = document.getElementById('CartDrawer');

  /* ---------- delivery date ---------- */
  function setDelivery() {
    var d = new Date();
    d.setDate(d.getDate() + (S.deliveryDays || 2));
    var txt = 'Get it by ' + d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-delivery]').forEach(function (el) { el.textContent = txt; });
  }
  setDelivery();

  /* ---------- mobile menu ---------- */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (menuBtn && menu) menuBtn.addEventListener('click', function () { menu.classList.toggle('is-open'); });

  /* ---------- drawer ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && drawer) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderDrawer(html) {
    if (!html || !drawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var current = document.getElementById('CartDrawerInner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var src = document.querySelector('[data-cart-count-source]');
    var count = src ? parseInt(src.textContent, 10) : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }

  /* quantity change inside drawer */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-set-qty]');
    if (!b) return;
    drawer.classList.add('is-busy');
    post((S.cartChangeUrl || '/cart/change') + '.js', {
      line: parseInt(b.dataset.line, 10),
      quantity: Math.max(0, parseInt(b.dataset.setQty, 10)),
      sections: 'cart-drawer'
    })
      .then(function (j) { renderDrawer(j.sections && j.sections['cart-drawer']); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  });

  /* ---------- product page ---------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-btn]');
    var errEl = form.querySelector('[data-form-error]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var jsonEl = document.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

    form.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v + parseInt(b.dataset.qtyStep, 10));
      });
    });

    var select = form.querySelector('[data-variant-select]');
    if (select && product) {
      select.addEventListener('change', function () {
        var v = product.variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        var inStock = document.querySelector('[data-instock]');
        var soldOut = document.querySelector('[data-soldout]');
        if (inStock) inStock.hidden = !v.available;
        if (soldOut) soldOut.hidden = v.available;
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        fetch(url.pathname + '?variant=' + v.id + '&section_id=' + document.querySelector('[data-product-price]').closest('[id^="shopify-section-"]').id.replace('shopify-section-', ''))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var p = doc.querySelector('[data-product-price]');
            if (p) document.querySelector('[data-product-price]').innerHTML = p.innerHTML;
          });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      post((S.cartAddUrl || '/cart/add') + '.js', {
        items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }],
        sections: 'cart-drawer'
      })
        .then(function (j) {
          renderDrawer(j.sections && j.sections['cart-drawer']);
          openDrawer();
        })
        .catch(function (err) {
          errEl.textContent = err.message;
          errEl.hidden = false;
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = label;
        });
    });
  }

  /* ---------- collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });
})();
